module.exports = __webpack_public_path__ + "img/social-friens-request-eng.475243b9.png";